<template>
    <div>
        <div
            :id="id"
            class="modal slide-in-top"
            aria-modal="true"
            tabindex="-1"
            role="dialog"
            v-show="isVisible"
            :aria-hidden="isVisible"
            :class="{ 'd-block': isVisible }"
            @click.self="close"
        >
            <div :class="{ [`modal-dialog modal-${size}`]: true, 'modal-dialog-centered': centered }" role="document">
                <div class="modal-content">
                    <header class="modal-header d-flex">
                        <h5 class="modal-title" v-if="$slots.title || title">
                            <slot name="title">{{ title }}</slot>
                        </h5>
                        <button class="btn btn-close ml-auto" v-if="headerClose" @click.prevent="close">
                            <i class="fal fa-fw fa-times"></i>
                        </button>
                    </header>
                    <div class="modal-body">
                        <slot :close="close"></slot>
                    </div>
                    <footer class="modal-footer" v-if="$slots.footer">
                        <slot name="footer"></slot>
                    </footer>
                </div>
            </div>
        </div>
        <div class="modal-backdrop fade show" v-show="isVisible" @click.prevent="close"></div>
        <span @click="open">
            <slot name="button"></slot>
        </span>
    </div>
</template>

<script>
export default {
    props: {
        id: {
            default: 'modal',
        },
        visible: {
            default: false,
        },
        size: {
            default: 'md',
        },
        centered: {
            default: false,
        },
        title: {
            default: null,
        },
        headerClose: {
            default: true,
        },
    },
    data() {
        return {
            isVisible: null,
        };
    },
    created() {
        Bus.$on('close-modal', this.closeById);
        Bus.$on('open-modal', this.openById);
    },
    mounted() {
        const self = this;
        Array.prototype.forEach.call(this.$el.querySelectorAll('[data-close-modal]'), function (child, i) {
            child.addEventListener('click', self.close);
        });
    },
    beforeDestroy() {
        const self = this;
        Bus.$off('close-modal', this.closeById);
        Array.prototype.forEach.call(this.$el.querySelectorAll('[data-close-modal]'), function (child, i) {
            child.removeEventListener('click', self.close);
        });
    },
    methods: {
        open(e) {
            if (e) {
                e.preventDefault();
            }

            this.isVisible = true;
        },
        close(e) {
            if (e) {
                e.preventDefault();
            }

            this.isVisible = false;
        },
        openById(id) {
            if (id && id === this.id) {
                return this.open();
            }

            return this.open();
        },
        closeById(id) {
            if (id && id === this.id) {
                return this.close();
            }

            return this.close();
        },
    },
    watch: {
        visible: {
            immediate: true,
            handler(newVal) {
                this.isVisible = newVal;
            },
        },
        isVisible: {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    document.querySelector('body').classList.add('modal-open');
                } else {
                    document.querySelector('body').classList.remove('modal-open');
                }
            },
        },
    },
};
</script>
